import { GatewayNetworkModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/networks/models/outputs/gateway-network.model';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';

import { NetworkListActionsColumn } from '@app/feature/network/network-list/network-list-actions.column';
import { NetworkListDescriptionColumn } from '@app/feature/network/network-list/network-list-description.column';
import { NetworkListIdColumn } from '@app/feature/network/network-list/network-list-id.column';
import { NetworkListNameColumn } from '@app/feature/network/network-list/network-list-name.column';

// /////////////////////////////////////////////////////////////////////////////
// DISPLAYING
// /////////////////////////////////////////////////////////////////////////////

export const customerNetworkListColumnHelper =
  createColumnHelper<GatewayNetworkModel>();

type ResourceColumnType = ColumnDef<GatewayNetworkModel, any>[];

export const CUSTOMER_NETWORK_LIST_COLUMN_LIST: ResourceColumnType = [
  customerNetworkListColumnHelper.accessor('id', NetworkListIdColumn),
  customerNetworkListColumnHelper.accessor('name', NetworkListNameColumn),
  customerNetworkListColumnHelper.accessor(
    'description',
    NetworkListDescriptionColumn,
  ),
  customerNetworkListColumnHelper.display(NetworkListActionsColumn),
];

export const CUSTOMER_NETWORK_LIST_COLUMN_ID_LIST =
  CUSTOMER_NETWORK_LIST_COLUMN_LIST.flatMap((columnDef) => {
    if ('accessorKey' in columnDef) {
      return [columnDef.id ?? (columnDef.accessorKey as string)];
    }

    if (columnDef.id) {
      return [columnDef.id];
    }

    return [];
  });

export const CUSTOMER_NETWORK_LIST_COLUMN_ORDER = [
  ...CUSTOMER_NETWORK_LIST_COLUMN_ID_LIST,
];

export const CUSTOMER_NETWORK_LIST_COLUMN_VISIBILITY =
  CUSTOMER_NETWORK_LIST_COLUMN_ID_LIST.reduce((columnVisibility, columnId) => {
    return { ...columnVisibility, [columnId]: true };
  }, {});
